import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter)
import login from '../views/login/login.vue';
const routes = [{
		path: '/login',
		name: 'login',
		component: login
	},
]

const router = new VueRouter({
	mode: 'history',
	routes
});
router.beforeEach((to, from, next) => {
	let isLogin = localStorage.getItem('isLogin')
	// let token = localStorage.getItem('token')
	if (isLogin) {
		location.href = '/'
	} else {
		next()
	}
});
export default router
